import React from 'react';
import { useMutation, useQuery } from '@apollo/react-hooks';
import useReactRouter from 'use-react-router';
import { t } from 'ttag';
import { useNavigator } from '../components/Navigator';
import useNotifier from '../components/Messages/hooks';
import { extractDataError } from '../utils/errors';

const userEditForm = ({ schema, router, onComplete }) => {
  const { match } = useReactRouter();
  const { id } = match.params;
  const navigate = useNavigator();
  const pushMessage = useNotifier();
  const [oneQuery, oneKey] = schema.one();
  const [updateMutation, updateKey] = schema.update();
  const [state, setState] = React.useState({
    errors: [],
    submitLoading: false,
  });
  const { loading, data, refetch } = useQuery(oneQuery, {
    variables: { id },
    fetchPolicy: 'network-only',
  });

  const [doUpdate] = useMutation(updateMutation, {
    onCompleted: (d) => {
      setState({ ...state, submitLoading: false });
      const res = d[updateKey];
      if (res.ok) {
        if (onComplete) {
          onComplete(d);
          return;
        }
        navigate(router.list());
      } else {
        const dataError = extractDataError(res.errors);
        if (dataError) {
          pushMessage({ text: dataError });
        } else {
          pushMessage({
            text: t`Виникла помилка, перевірте чи всі поля заповнені`,
          });
        }
        setState({ ...state, errors: res.errors, submitLoading: false });
      }
    },
  });

  const onSubmit = (formData) => {
    setState({ ...state, submitLoading: true });
    doUpdate({ variables: { id, inputData: formData } });
  };

  return {
    id,
    loading,
    submitLoading: state.submitLoading,
    data: data && data[oneKey],
    dataCert: data && data[oneKey],
    dataTrainer: data && data[oneKey],
    onSubmit,
    errors: state.errors,
    refetch,
  };
};

export default userEditForm;
